// env
import {
	PUBLIC_STRIPE_PRODUCT_ID_BASIC,
	PUBLIC_STRIPE_PRODUCT_ID_GROW,
	PUBLIC_STRIPE_PRODUCT_ID_PRO,
} from '$env/static/public';

// icons
import IbmZCloudModStack from 'carbon-icons-svelte/lib/IbmZCloudModStack.svelte';
import ProgressBarRound from 'carbon-icons-svelte/lib/ProgressBarRound.svelte';
import Undo from 'carbon-icons-svelte/lib/Undo.svelte';
import SendAlt from 'carbon-icons-svelte/lib/SendAlt.svelte';

// types
import type { Kit } from '$types/Kit';

export const claimableSpots = 10;

export const refundTime = 15;

export const tokenLife = 365;

export const kits: Kit[] = [
	{
		id: PUBLIC_STRIPE_PRODUCT_ID_BASIC,
		amount: 30,
		eventId: 'XQHVACKA',
		features: function () {
			return [
				{
					icon: ProgressBarRound,
					title: `${this.tokenCount} tokens @ $${this.amount / this.tokenCount}/token`,
				},
				{ icon: Undo, title: 'Self-service token refunds' },
				{ icon: IbmZCloudModStack, title: 'Limited access to Buyout' },
			];
		},
		shortTitle: 'basic',
		tokenCount: 5,
	},
	{
		id: PUBLIC_STRIPE_PRODUCT_ID_GROW,
		amount: 75,
		eventId: 'YLHXFJCE',
		features: function () {
			return [
				{
					icon: ProgressBarRound,
					title: `${this.tokenCount} tokens @ $${this.amount / this.tokenCount}/token`,
				},
				{ icon: Undo, title: 'Self-service token refunds' },
				{ icon: IbmZCloudModStack, title: 'Full access to Buyout' },
			];
		},
		shortTitle: 'grow',
		tokenCount: 15,
	},
	{
		id: PUBLIC_STRIPE_PRODUCT_ID_PRO,
		amount: 120,
		eventId: 'N3TNUW7P',
		features: function () {
			return [
				{
					icon: ProgressBarRound,
					title: `${this.tokenCount} tokens @ $${this.amount / this.tokenCount}/token`,
				},
				{ icon: Undo, title: 'Self-service token refunds' },
				{ icon: IbmZCloudModStack, title: 'Full access to Buyout' },
				{ icon: SendAlt, title: 'Priority email support' },
			];
		},
		shortTitle: 'pro',
		tokenCount: 30,
	},
];
